export function getJwtPayload() {
  const token = localStorage.getItem('token_plataforma_digital');
  if (!token) return null;
  try {
    const [, payloadB64] = token.split('.');
    const base64 = payloadB64.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}
